// extracted by mini-css-extract-plugin
export default {"salesmanager":"styles_salesmanager__uF6qH"};